import React from 'react'

import ViewName from "./view-name"
import TypeField from "./type-field"
import ViewAccessBlock from "./view-access"
import ViewLocation from "./view-location"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import CustomView from "../../../../../../../core/model2/custom-view/custom-view"

type Props = {
    view        : CustomView
    form        : FormManager
    mode        : 'create' | 'update'

    hideAccess? : boolean
}

// const debug = "CommonBlock"
const debug = false

export default function CommonBlock(props: Props) {

    debug && console.log(debug, 'render', props)

    const showTypeField = props.mode === 'update'
    const showAccess    = props.view.canShare && !props.hideAccess

    return (
        <>
            <ViewName form={props.form}/>
            <ViewLocation form={props.form} view={props.view} />
            {showTypeField && <TypeField view={props.view} />}
            {showAccess && <ViewAccessBlock form={props.form} view={props.view}/>}
            <div className="row subgroup"/>
        </>
    )
}